export function BrandMark({
  className = "",
  size = "md",
}: {
  className?: string;
  size?: "sm" | "md" | "lg";
}) {
  const sz =
    size === "sm"
      ? "text-[22px]"
      : size === "lg"
      ? "text-[34px]"
      : "text-[28px]";
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span
        className={`${sz} font-display font-bold leading-none tracking-tight text-white`}
      >
        F<span className="text-accent">.</span>
      </span>
    </div>
  );
}

export function BrandWordmark({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <span className="text-[22px] font-display font-bold leading-none text-white">
        F<span className="text-accent">.</span>
      </span>
      <span className="text-[14px] font-semibold tracking-tight text-white/90">
        Fintegrator<span className="text-accent">Bot</span>
      </span>
    </div>
  );
}

/** Fullscreen hero background image from fintegrator.eu (dark wavy
 *  composition with particle sphere baked in at the correct colors).
 *  Use inside `relative overflow-hidden`. */
export function HeroBg({
  className = "",
  opacity = 0.75,
}: {
  className?: string;
  opacity?: number;
}) {
  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute inset-0 bg-cover bg-center bg-no-repeat ${className}`}
      style={{
        backgroundImage: "url(/hero-bg.jpg)",
        opacity,
      }}
    />
  );
}
